
import { Box } from '@chakra-ui/react'
import React, { useEffect, useState } from 'react'
import AllOrder from '../../component/AllOrder'
import axios from 'axios'
import { Auth } from '../../component/Auth'

const Individuals = () => {
  const [tData, setTData] = useState([]);
  const [isLoading, setIsLoading] = useState({loading: true, error: false})

  const fetchOrders = () => {
    let config = {
      method: 'get',
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_RALCO_API_URL}/api/order?customerType=INDIVIDUAL`,
      headers: { 
        'Authorization': Auth()
    }
    };

    axios.request(config)
    .then((response) => {
      setTData(response.data)
      setIsLoading({loading: false, error: false})
    })
    .catch((error) => {
      console.log(error);
      setIsLoading({loading: false, error: true})
    });
  }

  const refreshOrders = (data) => {
    if (data) {
      setTData(data)
    } else {
      fetchOrders()
    }
  }

  useEffect(() => {
    fetchOrders()
  },[])

  return (
    <Box p={5} flex="1" w={'100%'}>
      <AllOrder
        title={"Ended"}
        head={["Order", "Date" , "Customer Name", "Total" , "Items", "Order Status" , "Action", ""]}
        data={tData}
        isLoading={isLoading}
        refreshOrders={refreshOrders}
      />
    </Box>
  )
}

export default Individuals